import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { sidebarStore } from "shared/common/stores/sidebarStore";
import MeasureResultField from "./MeasureResultField";

interface VerticalDistance {
  id: string;
  label: string;
  value: string;
  accuarcy: string;
}

export default function VerticalDistanceContent() {
  const verticalDistanceToolValues = sidebarStore(
    (state) => state.verticalDistanceToolValues
  );
  const verticalDistanceActiveAttributes = sidebarStore(
    (state) => state.verticalDistanceActiveAttributes
  );
  const changeVerticalDistanceActiveAttributes = sidebarStore(
    (state) => state.changeVerticalDistanceActiveAttributes
  );

  const { t } = useTranslation();

  const defaultValue = "0.00";
  const [height, setHeight] = useState<string>(defaultValue);
  const [accuaryHeight, setAccuaryHeight] = useState<string>(defaultValue);

  //attributes list
  const attributes: VerticalDistance[] = [
    {
      id: "plumb_line",
      label: t("vertical.plumb_line"),
      value: height,
      accuarcy: accuaryHeight,
    },
  ];

  //update states for height
  useEffect(() => {
    if (verticalDistanceToolValues !== undefined) {
      setHeight(verticalDistanceToolValues.distance.toFixed(2));
      setAccuaryHeight(verticalDistanceToolValues.precDistance.toFixed(2));
    } else {
      setHeight(defaultValue);
      setAccuaryHeight(defaultValue);
    }
  }, [verticalDistanceToolValues]);

  return (
    <Box
      width="100%"
      display={"flex"}
      alignItems={"start"}
      flexDirection={"column"}
      gap={0.5}
    >
      {attributes.map((item: VerticalDistance) => (
        <MeasureResultField
          key={item.id}
          id={item.id}
          title={item.label}
          value={item.value + " m"}
          loggingString={"VertDistance"}
          activeAttributes={verticalDistanceActiveAttributes}
          changeActiveAttributes={changeVerticalDistanceActiveAttributes}
          showPin={attributes.length > 1}
        />
      ))}
    </Box>
  );
}
